import React,{useState,useEffect} from 'react';
import { Box, Flex, Avatar, Text, CircularProgress, CircularProgressLabel, Card } from '@chakra-ui/react';
import { FaUserCircle } from 'react-icons/fa';
import backgroundImage from '../../assets/postjob.jpg'; // Import your background image
import axios from 'axios'; // Import axios for making API requests
// Import your background image

const ProfileStatus = () => {
  const [profileData, setProfileData] = useState({
    profile_image_url: '',
    FullName: '',
    email: '',
    contact_no: '',
    gender: '',
    country_code: '',
    address: {
      country: { name: '' },
      contact_address: '',
      pinCode: { postalCode: '' }
    },
    bio: '',
    experience: '',
    registerNumber: '',
    individual_identity: ''
  });

  const [isLoading, setIsLoading] = useState(true);

  const calculateProfileCompletion = () => {
    const fieldPercentages = {
      FullName: 10,                    // Name: 10%
      email: 10,                       // Email: 10%
      contact_no: 10,                  // Contact Number: 10%
      gender: 5,                       // Gender: 5%
      country_code: 5,                 // Country Code: 5%
      'address.country.name': 5,       // Country: 5%
      'address.contact_address': 10,   // Address: 10%
      'address.pinCode.postalCode': 20,// Pin Code: 20%
      bio: 10,                         // Bio: 10%
      experience: 10,                  // Experience: 10%
      registerNumber: 5,               // Register Number: 5%
      individual_identity: 5           // Identity Number: 5%
    };

    let completionPercentage = 0;

    Object.entries(fieldPercentages).forEach(([field, percentage]) => {
      const value = field.includes('.')
        ? field.split('.').reduce((obj, key) => obj?.[key], profileData)
        : profileData[field];

      if (value && value.toString().trim() !== '') {
        completionPercentage += percentage;
      }
    });

    // Cap the completion at 90%
    return Math.min(completionPercentage, 90);
  };

  useEffect(() => {
    const fetchProfileData = async () => {
      setIsLoading(true);
      const ticketToken = sessionStorage.getItem('ticketToken');
      if (!ticketToken) {
        console.error('No ticket token found in sessionStorage');
        setIsLoading(false);
        return;
      }

      try {
        const response = await axios.get(
          `${process.env.REACT_APP_SERVER_URL}/applicant/get-applicant-details`,
          {
            headers: {
              Authorization: `Bearer ${ticketToken}`
            }
          }
        );

        setProfileData(response.data.data);
        setIsLoading(false);
      } catch (error) {
        console.error('Error fetching profile data:', error);
        setIsLoading(false);
      }
    };

    fetchProfileData();
  }, []);

  const completionPercentage = calculateProfileCompletion();
  const progressColor = completionPercentage >= 75 ? "blue.400" : 
                       completionPercentage >= 50 ? "green.300" : 
                       completionPercentage >= 25 ? "yellow.200" : "red.100";

  return (
    <Box
      width="100%"
      height="100%"
      bgSize="cover"
      bgPosition="center"
      position="relative"
    >
      <Card
        bg="gray.100"
        shadow="md"
        borderRadius="md"
        width="250px"
        p={3}
        position="absolute"
        bottom={4}
        left={4}
      >
        <Flex
          direction="row"
          align="center"
          justify="flex-start"
          textAlign="left"
        >
          <Box position="relative" mr={3}>
            {isLoading ? (
              <CircularProgress 
                isIndeterminate 
                color="blue.300" 
                size="60px" 
                thickness="6px"
              >
                <CircularProgressLabel fontSize="xs">...</CircularProgressLabel>
              </CircularProgress>
            ) : (
              <CircularProgress 
                value={completionPercentage} 
                color={progressColor}
                trackColor="gray.100"
                size="60px" 
                thickness="6px"
              >
                <CircularProgressLabel fontSize="xs">
                  {completionPercentage}%
                </CircularProgressLabel>
              </CircularProgress>
            )}
            <Avatar
              size="sm"
              src={profileData.profile_image_url}
              icon={<FaUserCircle />}
              position="absolute"
              top="50%"
              left="50%"
              transform="translate(-50%, -50%)"
            />
          </Box>
          <Box>
            <Text fontWeight="bold" mb={1} fontSize="sm">
              {profileData.FullName || 'Complete your profile'}
            </Text>
            <Text mt={2} fontSize="xs" color="gray.600">
              {isLoading ? 'Loading profile...' :
               completionPercentage === 100 ? `Profile complete (${completionPercentage}%)` :
               completionPercentage >= 90 ? `Almost there! (${completionPercentage}%)` :
               completionPercentage >= 75 ? `Great progress! (${completionPercentage}%)` :
               completionPercentage >= 50 ? `You're halfway there! (${completionPercentage}%)` :
               completionPercentage >= 25 ? `Keep going, you're making progress! (${completionPercentage}%)` :
               `Start completing your profile to unlock all features! (${completionPercentage}%)`
               }
            </Text>
          </Box>
        </Flex>
      </Card>
    </Box>
  );
};

export default ProfileStatus;